import React, { useState, useEffect } from 'react';
import {
    BenchSheetTechnologyType, DocumentType, Entities, FtirAnalysisType,
    MessageBoxReplyType, ModalMessageType, NoteType
} from '../models/enums';
import { DocumentationConstants } from '../store/documentation-constants';
import { FtirBenchSheet } from '../models/ftir-bench-sheet';
import BenchSheetToolbar from './BenchSheetToolbar';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import { ItemBasicInformation } from '../models/item-basic-information';
import BenchSheetHeaderComponent from './BenchSheetHeaderComponent';
import SecondaryBenchSheetInstrument from './SecondaryBenchSheetInstrument';
import FtirDataComponent from './FtirDataComponent';
import FtirSpectralCoefficientsData from './FtirSpectralCoefficientsData';
import BenchSheetData from './BenchSheetData';
import NoteViewer from './NoteViewer';
import { CrudFunctions } from '../utilities/crud-functions';
import DocumentLoader from './DocumentLoader';
import TicketLogEntryForm from './TicketLogEntryForm';
import { UserDataStore } from '../store/userDataStore';
import { ModalMetadata } from '../models/modal-metadata';
import GlobalDialog from './Modal/GlobalDialog';
//import { MessageBoxReply } from '../models/message-box-reply';
import DmaFooter from './DmaFooter';

//import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';

//const DELETE_RECRYSTALIZATION_WARNING = 10;
//const DELETE_DRIED_WARNING = 20;
//const DELETE_SALT_WARNING = 30;

let key = 1;

/*
Keep all the commented sections for now
They will likely be re-added later
*/

export default function FtirBenchSheetForm() {
    const [benchSheet, setBenchSheet] =
        useState<FtirBenchSheet>();

    const [ticketLogEntryDialogVisible, setTicketLogEntryDialogVisible] =
        useState<boolean>();

    const [spectralGraphUpdateKey, setSpectralGraphUpdateKey] =
        useState<number>(1);

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    /*
    const [isRecrystalization, setIsRecrystalization] =
        useState<boolean>();

    const [isDried, setIsDried] =
        useState<boolean>();

    const [isSalt, setIsSalt] =
        useState<boolean>();
    */

    useEffect(() => {
        getAllData();
        //initSetTabs();
    }, []);

    const parts = window.location.href.split('/');
    const benchSheetId = parts[parts.length - 1];

    key++;
    const user = UserDataStore.getCurrentUser();
    const canEditRoles = ["SA", "QCBS-A", "QCBS-L", "QCBS-T"];
    const canEdit = canEditRoles.some(r => user.roleCodes && user.roleCodes.includes(r));
    const canInsertRoles = ["SA", "QCBS-A", "QCBS-L"];
    const canInsert = canEditRoles.some(r => user.roleCodes && user.roleCodes.includes(r));
    const canDeleteRoles = ["SA", "QCBS-A"];
    const canDelete = canEditRoles.some(r => user.roleCodes && user.roleCodes.includes(r));

    const batchId = benchSheet && benchSheet.batchId ? benchSheet.batchId : undefined;

    return (
        <div className="pw-content">
            <BenchSheetToolbar title="FTIR Bench Sheet"
                subtitle="Fourier-Transform Infrared Spectroscopy"
                auditRowPointer={benchSheetId} entity={Entities.FtirBenchSheets}
                technologyId={BenchSheetTechnologyType.FourierTransformInfraredSpectroscopy}
                documentationId={DocumentationConstants.FTIRBenchSheet}
                showItemInformation={showBatchInformationDialog}
                showTicketLog={showTicketLogEntryDialog} />

            <BenchSheetHeaderComponent benchSheetId={benchSheetId}
                readOnly={!canEdit} fixedReference="In house" />

            <SecondaryBenchSheetInstrument benchSheetId={benchSheetId} isReadOnly={!canEdit}
                technology={BenchSheetTechnologyType.FourierTransformInfraredSpectroscopy}
                title="Instrument" headerBgClass="pw-bg-vc-600" />

            {/* LEAVE ALL THIS FOR NOW
            <div className="pw-form-row">
                {!isRecrystalization &&
                    <Button className="pw-margin-top-05"
                        text="Add Recrystalization" icon="plus" type="success"
                        hint="add recrystalization"
                        onClick={addRecrystalization} />
                }
                {isRecrystalization &&
                    <Button className="pw-margin-top-05"
                        text="Remove Recrystalization" icon="trash" type="normal"
                        hint="remove recrystalization"
                        onClick={onRemoveRecrystalizationClick} />
                }
                {!isDried &&
                    <Button className="pw-margin-top-05 pw-margin-left-05"
                        text="Add Drying" icon="plus" type="success"
                        hint="add drying"
                        onClick={addDrying} />
                }
                {isDried &&
                    <Button className="pw-margin-top-05 pw-margin-left-05"
                        text="Remove Drying" icon="trash" type="normal"
                        hint="remove drying"
                        onClick={onRemoveDryingClick} />
                }
                {!isSalt &&
                    <Button className="pw-margin-top-05 pw-margin-left-05"
                        text="Add Salt" icon="plus" type="success"
                        hint="add salt"
                        onClick={addSalt} />
                }
                {isSalt &&
                    <Button className="pw-margin-top-05 pw-margin-left-05"
                        text="Remove Salt" icon="trash" type="normal"
                        hint="remove salt"
                        onClick={onRemoveSaltClick} />
                }
            </div>
            
            <div id="pb-navigation-pane" className="pw-margin-top-05" >
                <div id="tab-buttons-panel" className="tab-buttons-container">
                    <div id="defaultPanelButton" onClick={onPanelButtonClick}>As Is</div>

                    {isRecrystalization &&
                        <div id="recrystalizedPanelButton" onClick={onPanelButtonClick}>Recrystalized</div>
                    }
                    {isDried &&
                        <div id="dryingPanelButton" onClick={onPanelButtonClick}>Drying</div>
                    }
                    {isSalt &&
                        <div id="saltPanelButton" onClick={onPanelButtonClick}>Salt</div>
                    }
                </div>
            </div>
            */}

            <div id="defaultPanel">
                <FtirSpectralCoefficientsData benchSheetId={benchSheetId} isReadOnly={!canEdit}
                    ftirAnalysisType={FtirAnalysisType.AsIs} headerBgClass="pw-bg-rg-600" />

                <div className="pw-margin-top-1">
                    <FtirDataComponent benchSheetId={benchSheetId} isReadOnly={!canEdit}
                        ftirAnalysisType={FtirAnalysisType.AsIs} headerBgClass="pw-bg-rb-600" />
                </div>
            </div>

            {/*
            <div id="recrystalizedPanel">
                {isRecrystalization &&
                    <>
                        <FtirSpectralCoefficientsData benchSheetId={benchSheetId} isReadOnly={!canEdit}
                            onDataReceived={onRecrystalizationSpectralCoefficientsDataReceived}
                            ftirAnalysisType={FtirAnalysisType.Recrystalized} />

                        <FtirDataComponent benchSheetId={benchSheetId} isReadOnly={!canEdit}
                            ftirAnalysisType={FtirAnalysisType.Recrystalized} />
                    </>
                }
            </div>

            <div id="dryingPanel">
                {isDried &&
                    <>
                        <FtirSpectralCoefficientsData benchSheetId={benchSheetId} isReadOnly={!canEdit}
                            onDataReceived={onDriedSpectralCoefficientsDataReceived}
                            ftirAnalysisType={FtirAnalysisType.Dried} />

                        <FtirDataComponent benchSheetId={benchSheetId} isReadOnly={!canEdit}
                            ftirAnalysisType={FtirAnalysisType.Dried} />
                    </>
                }
            </div>

            <div id="saltPanel">
                {isSalt &&
                    <>
                        <FtirSpectralCoefficientsData benchSheetId={benchSheetId} isReadOnly={!canEdit}
                            onDataReceived={onSaltSpectralCoefficientsDataReceived}
                            ftirAnalysisType={FtirAnalysisType.Salt} />

                        <FtirDataComponent benchSheetId={benchSheetId} isReadOnly={!canEdit}
                            ftirAnalysisType={FtirAnalysisType.Salt} />
                    </>
                }
            </div>
            */}

            <div className="pw-comp-row-scroll-fixed-grid">
                <NoteViewer height='10rem' title="Bench Sheet Note"
                    noteType={NoteType.Method} parentId={benchSheetId} />
            </div>

            <div className="pw-comp-row-scroll-fixed-grid">
                <BenchSheetData parentId={benchSheetId}
                    readOnly={!canEdit} canDelete={true}
                    technology={BenchSheetTechnologyType.FourierTransformInfraredSpectroscopy}
                    documentType={DocumentType.General}
                    imageHandlerTitle="C of A Images" />
            </div>

            <div>
                <div className="lq-header pw-margin-top-05">
                    <div className="lq-header-title">Standards Documents</div>
                </div>

                {/* Right now just have all standards documents listed under generic StandardsDocument type */}
                <DocumentLoader parentId={batchId} readOnly={true}
                    documentType={DocumentType.StandardsDocument}
                    canDelete={canDelete} />
            </div>

            <DmaFooter />

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {ticketLogEntryDialogVisible &&
                <DialogPopup visible={ticketLogEntryDialogVisible}
                    onHiding={hideTicketLogEntryDialog}
                    title="Ticket Log Entry"
                    width={'55rem'}
                    height={'45rem'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <TicketLogEntryForm formName="FTIR Bench Sheet" contextData={benchSheet}
                        onCancel={hideTicketLogEntryDialog}
                        onComplete={hideTicketLogEntryDialog}
                        key={`TLE${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata}
                    onClose={onGlobalDialogClose} />
            }

        </div>
    );

    /*
    function onGlobalDialogReply(reply: MessageBoxReply) {
        console.log("onGlobalDialogReply");
        console.log(reply);

        if (reply.code === DELETE_RECRYSTALIZATION_WARNING) {

            clearGlobalDialog();

            if (reply.reply !== MessageBoxReplyType.Yes)
                return;

            removeRecrystalization();
        }
        else if (reply.code === DELETE_DRIED_WARNING) {

            clearGlobalDialog();

            if (reply.reply !== MessageBoxReplyType.Yes)
                return;

            removeDrying();
        }
        else if (reply.code === DELETE_SALT_WARNING) {

            clearGlobalDialog();

            if (reply.reply !== MessageBoxReplyType.Yes)
                return;

            removeSalt();
        }
    }
    */

    function onGlobalDialogClose() {
        clearGlobalDialog();
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

    /*
    function onRecrystalizationSpectralCoefficientsDataReceived() {
        setIsRecrystalization(true);
    }
    function onDriedSpectralCoefficientsDataReceived() {
        setIsDried(true);
    }

    function onSaltSpectralCoefficientsDataReceived() {
        setIsSalt(true);
    }

    function onRecrystalizationDataReceived() {
        setIsRecrystalization(true);
    }
    function onDriedDataReceived() {
        setIsDried(true);
    }

    function onSaltDataReceived() {
        setIsSalt(true);
    }

    function addRecrystalization() {
        setIsRecrystalization(true);
    }

    function addDrying() {
        setIsDried(true);
    }

    function addSalt() {
        setIsSalt(true);
    }

    function onRemoveRecrystalizationClick() {
        //first prompt
        showPromptMessage(ModalMessageType.PromptYesNo, "FTIR Analysis Type Deletion", "This operation will delete all of the Recrystalization Data. This operation cannot be undone. Do you want to proceed?", DELETE_RECRYSTALIZATION_WARNING);
    }

    function onRemoveDryingClick() {
        //first prompt
        showPromptMessage(ModalMessageType.PromptYesNo, "FTIR Analysis Type Deletion", "This operation will delete all of the Dried Data. This operation cannot be undone. Do you want to proceed?", DELETE_DRIED_WARNING);
    }

    function onRemoveSaltClick() {
        //first prompt
        showPromptMessage(ModalMessageType.PromptYesNo, "FTIR Analysis Type Deletion", "This operation will delete all of the Salt Data. This operation cannot be undone. Do you want to proceed?", DELETE_SALT_WARNING);
    }

    async function removeRecrystalization() {
        console.log("about to delete Recryst...");

        await deleteFtirAnalysisData(FtirAnalysisType.Recrystalized)
            .then(data => {
                setIsRecrystalization(false);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error deleting FTIR Recrystalization Data");
            });
    }

    async function removeDrying() {
        console.log("about to delete Dry...");

        await deleteFtirAnalysisData(FtirAnalysisType.Dried)
            .then(data => {
                setIsDried(false);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error deleting FTIR Dried Data");
            });
    }

    async function removeSalt() {
        console.log("about to delete Salt...");

        await deleteFtirAnalysisData(FtirAnalysisType.Salt)
            .then(data => {
                setIsSalt(false);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error deleting FTIR Salt Data");
            });
    }
    */

    // GET

    async function getBenchSheet() {
        await CrudFunctions.getData(`benchsheets/ftirbenchsheetbasicdata/${benchSheetId}`)
            .then(data => {
                console.log("FTIR BS:");
                console.log(data);

                setBenchSheet(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error retrieving FTIR Basic Bench Sheet Data");
            });
    }

    async function checkSpectralCoefficientsByBenchsheetIdExist() {
        await CrudFunctions.getData(`benchsheets/checkspectralcoefficientsbybenchsheetidexist/${benchSheetId}`)
            .then(data => {
                console.log("SC EXIST:");
                console.log(data);

                const ftirAnalysisTypes = data as FtirAnalysisType[];

                /*
                if (ftirAnalysisTypes) {
                    if (ftirAnalysisTypes.includes(FtirAnalysisType.Recrystalized))
                        setIsRecrystalization(true);
                    if (ftirAnalysisTypes.includes(FtirAnalysisType.Dried))
                        setIsDried(true);
                    if (ftirAnalysisTypes.includes(FtirAnalysisType.Salt))
                        setIsSalt(true);
                }
                */
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error retrieving FTIR Basic Bench Sheet Data");
            });
    }

    async function deleteFtirAnalysisData(ftirAnalysisType: FtirAnalysisType) {
        if (benchSheetId && ftirAnalysisType)
            return await CrudFunctions.deleteData(`benchsheets/ftiranalysisdata/${benchSheetId}/${ftirAnalysisType}`);
    }

    //navigation

    async function getAllData() {
        await Promise.all([
            getBenchSheet(),
            checkSpectralCoefficientsByBenchsheetIdExist()
        ]);
    }

    /*
    function onPanelButtonClick(e: any) {
        resetAllButtons();

        const button = e.target as HTMLDivElement;

        if (button) {
            button.className = "tab-button-active";
        }

        hideAllComponents();

        const id: string = e.target.id;
        const panel = document.getElementById(id.replace("Button", "")) as HTMLDivElement;
        panel.style.display = "";
    }

    function resetAllButtons() {
        const defaultPanelButton = document.getElementById("defaultPanelButton") as HTMLDivElement;
        defaultPanelButton.className = "tab-button-inactive";

        const recrystalizedPanelButton = document.getElementById("recrystalizedPanelButton") as HTMLDivElement;
        if (recrystalizedPanelButton)
            recrystalizedPanelButton.className = "tab-button-inactive";

        const dryingPanelButton = document.getElementById("dryingPanelButton") as HTMLDivElement;
        if (dryingPanelButton)
            dryingPanelButton.className = "tab-button-inactive";

        const saltPanelButton = document.getElementById("saltPanelButton") as HTMLDivElement;
        if (saltPanelButton)
            saltPanelButton.className = "tab-button-inactive";
    }

    function hideAllComponents(onload: boolean = false) {
        if (!onload) {
            const defaultPanel = document.getElementById("defaultPanel") as HTMLDivElement;
            defaultPanel.style.display = "none";
        }

        const recrystalizedPanel = document.getElementById("recrystalizedPanel") as HTMLDivElement;
        if (recrystalizedPanel)
            recrystalizedPanel.style.display = "none";

        const dryingPanel = document.getElementById("dryingPanel") as HTMLDivElement;
        if (dryingPanel)
            dryingPanel.style.display = "none";

        const saltPanel = document.getElementById("saltPanel") as HTMLDivElement;
        if (saltPanel)
            saltPanel.style.display = "none";
    }

    function initSetTabs() {
        hideAllComponents(true);

        const defaultPanelTab = document.getElementById("defaultPanelButton") as HTMLDivElement;
        defaultPanelTab.click();
    }
    */

    function showBatchInformationDialog() {
        if (benchSheet) {
            let itemInformation: ItemBasicInformation = {
                rowPointer: benchSheetId,
                createTimestamp: benchSheet.createTimestamp,
                lastModifiedTimestamp: benchSheet.modifyTimestamp,
                createUser: benchSheet.createUser,
                modifyUser: benchSheet.modifyUser
            };

            setItemBasicInformation(itemInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(true);
    }

    function hideTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    /*
    function showPromptMessage(mode: ModalMessageType, title: string, message: string, code: number) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message,
            code: code
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
    */
}

